
import React from 'react';
import { X } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import { FormItem, FormLabel, FormMessage } from '@/components/ui/form';
import { ExchangePlatform } from '@/types/trader';

interface ExchangeSelectorProps {
  exchanges: ExchangePlatform[];
  selectedExchanges: ExchangePlatform[];
  onToggleExchange: (exchange: ExchangePlatform) => void;
  formErrors: { message?: string } | undefined;
}

export const ExchangeSelector = ({ 
  exchanges, 
  selectedExchanges, 
  onToggleExchange,
  formErrors 
}: ExchangeSelectorProps) => {
  return (
    <FormItem>
      <FormLabel>Target Exchanges</FormLabel>
      <div className="flex flex-wrap gap-2">
        {exchanges.map((exchange) => (
          <Badge
            key={exchange}
            variant={selectedExchanges.includes(exchange) ? "default" : "outline"}
            className="cursor-pointer"
            onClick={() => onToggleExchange(exchange)}
          >
            {exchange}
            {selectedExchanges.includes(exchange) && (
              <X 
                className="ml-1 h-3 w-3" 
                onClick={(e) => {
                  e.stopPropagation();
                  onToggleExchange(exchange);
                }} 
              />
            )}
          </Badge>
        ))}
      </div>
      {formErrors && (
        <p className="text-sm font-medium text-destructive">
          {formErrors.message}
        </p>
      )}
    </FormItem>
  );
};
